import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Web = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });
    }, []);

    return (
        <>
            {/* Page Header Start */}
            <div className="container-fluid page-header py-5" style={{ marginBottom: "6rem" }} data-aos="fade-down">
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Web Development</h1>
                </div>
            </div>
            {/* Page Header End */}

            {/* Introduction Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                            <div className="position-relative text-center">
                                <img src="img/web-1.jpg" className="img-fluid rounded shadow-lg w-100" alt="Web Development Services" style={{ maxHeight: "600px", objectFit: "cover" }} />
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
                            <h6 className="text-primary text-uppercase mb-2">Digital Solutions</h6>
                            <h1 className="display-6 mb-4">Professional Web Development Services</h1>
                            <p className="mb-4">A2Z Solutions provides comprehensive web development services to help businesses establish a strong online presence. We create custom, responsive, and scalable websites and web applications that drive growth and enhance user engagement.</p>

                            <p className="mb-4">Our team of experienced developers specializes in modern web technologies, ensuring your digital platform is not only visually appealing but also functional, secure, and optimized for performance across all devices.</p>

                            <div className="row g-3">
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="200">
                                    <div className="d-flex">
                                        <i className="fa fa-code text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Custom Development</h5>
                                            <p className="mb-0">Tailored web solutions</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="300">
                                    <div className="d-flex">
                                        <i className="fa fa-mobile-alt text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Responsive Design</h5>
                                            <p className="mb-0">Mobile-first approach</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Web Development Services Section */}
            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
                        <h6 className="text-primary text-uppercase">Our Expertise</h6>
                        <h1 className="display-6 mb-4">Comprehensive Web Development Solutions</h1>
                    </div>

                    <div className="row g-5">
                        {/* Frontend Development */}
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <div className="text-center mb-4">
                                    <i className="fa fa-paint-brush text-primary fa-3x mb-3"></i>
                                    <h3 className="mb-3">Frontend Development</h3>
                                </div>
                                
                                <p className="mb-4">We create visually stunning and highly interactive user interfaces using modern frontend technologies that provide seamless user experiences across all devices.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">Our Frontend Stack:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> React.js & Next.js Development</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Angular & Vue.js Applications</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Responsive HTML5, CSS3 & JavaScript</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Bootstrap & Tailwind CSS</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Progressive Web Apps (PWA)</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> UI/UX Design Implementation</li>
                                    </ul>
                                </div>

                                {/* <div className="text-center mt-4">
                                    <img 
                                        src="img/frontend-dev.jpg" 
                                        className="img-fluid rounded shadow" 
                                        alt="Frontend Development"
                                        style={{ maxHeight: "200px", objectFit: "cover", width: "100%" }}
                                    />
                                </div> */}
                            </div>
                        </div>

                        {/* Backend Development */}
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <div className="text-center mb-4">
                                    <i className="fa fa-server text-primary fa-3x mb-3"></i>
                                    <h3 className="mb-3">Backend Development</h3>
                                </div>
                                
                                <p className="mb-4">We build robust, scalable, and secure backend systems that power your web applications, ensuring optimal performance and data management.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">Our Backend Expertise:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Node.js & Express.js Development</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Python Django & Flask</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> PHP Laravel & CodeIgniter</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> RESTful & GraphQL APIs</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Database Design & Optimization</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Microservices Architecture</li>
                                    </ul>
                                </div>

                                {/* <div className="text-center mt-4">
                                    <img 
                                        src="img/backend-dev.jpg" 
                                        className="img-fluid rounded shadow" 
                                        alt="Backend Development"
                                        style={{ maxHeight: "200px", objectFit: "cover", width: "100%" }}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Web Development Content Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <h2 className="mb-4" data-aos="fade-up" data-aos-delay="100">Our Web Development Services</h2>

                            <p className="mb-4" data-aos="fade-up" data-aos-delay="150">From simple business websites to complex web applications, A2Z Solutions offers end-to-end web development services tailored to your specific business needs and objectives.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="200">Custom Website Development</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="250">We design and develop custom websites that reflect your brand identity and business goals. Our websites are built with clean code, SEO-friendly structure, and responsive design to ensure optimal performance across all devices and platforms.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="300">E-commerce Solutions</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="350">Complete e-commerce website development with shopping carts, payment gateway integration, inventory management, and admin panels. We build secure online stores that provide seamless shopping experiences and drive conversions.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="400">Content Management Systems</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="450">We develop and customize CMS platforms like WordPress, Joomla, and Drupal, allowing you to easily manage and update your website content without technical expertise. Our CMS solutions are user-friendly, secure, and scalable.</p>

                            <div className="text-center my-5" data-aos="zoom-in" data-aos-delay="500">
                                <img src="img/web-2.jpg" className="img-fluid rounded shadow-lg w-75" alt="Web Development Process" style={{ maxHeight: "450px", objectFit: "cover" }} />
                            </div>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="550">Web Application Development</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="600">Custom web applications for business automation, customer relationship management, project management, and other specific business needs. We develop scalable applications that streamline your operations and improve efficiency.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="650">API Development & Integration</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="700">Custom API development and third-party API integration services. We connect your web applications with external services, payment gateways, social media platforms, and other systems to enhance functionality.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="750">Website Maintenance & Support</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="800">Ongoing website maintenance, security updates, performance optimization, and technical support services. We ensure your website remains secure, up-to-date, and performs optimally at all times.</p>

                            <h2 className="mb-4 mt-5" data-aos="fade-up" data-aos-delay="850">Our Development Process</h2>

                            <div className="row g-4">
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="900">
                                    <div className="bg-light p-4 rounded h-100 text-center">
                                        <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                            <i className="fa fa-lightbulb fa-2x"></i>
                                        </div>
                                        <h5 className="mb-3">Discovery & Planning</h5>
                                        <p className="mb-0">Understanding your requirements, target audience, and business objectives to create a comprehensive project plan.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="950">
                                    <div className="bg-light p-4 rounded h-100 text-center">
                                        <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                            <i className="fa fa-pencil-alt fa-2x"></i>
                                        </div>
                                        <h5 className="mb-3">Design & Prototyping</h5>
                                        <p className="mb-0">Creating wireframes, mockups, and prototypes to visualize the user interface and user experience.</p>
                                    </div>
                                </div>
                                <div className="col-md-4" data-aos="fade-up" data-aos-delay="1000">
                                    <div className="bg-light p-4 rounded h-100 text-center">
                                        <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                            <i className="fa fa-code fa-2x"></i>
                                        </div>
                                        <h5 className="mb-3">Development & Testing</h5>
                                        <p className="mb-0">Coding, integration, and rigorous testing to ensure functionality, performance, and security standards.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-light p-4 rounded mt-5" data-aos="fade-up" data-aos-delay="1050">
                                <h4 className="mb-3">Why Choose A2Z Solutions for Web Development?</h4>
                                <p className="mb-3">Our team of certified developers has expertise in the latest web technologies and follows industry best practices. We stay updated with emerging trends to provide modern and effective web solutions.</p>

                                <p className="mb-3">We take a client-centric approach, working closely with you throughout the development process to ensure the final product aligns with your vision and business goals. Our transparent communication keeps you informed at every stage.</p>

                                <p className="mb-3">We prioritize clean code, security, and scalability in all our projects. Our websites are built to perform well, rank higher in search results, and provide excellent user experiences.</p>

                                <p className="mb-0">From startups to established enterprises, we have experience working with businesses of all sizes across various industries. Our flexible engagement models and competitive pricing make professional web development accessible to all.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Technologies We Use Section */}
            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
                        <h6 className="text-primary text-uppercase">Our Tech Stack</h6>
                        <h1 className="display-6 mb-4">Technologies We Work With</h1>
                    </div>

                    <div className="row text-center g-4" data-aos="fade-up" data-aos-delay="150">
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-react text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">React</h6>
                            </div>
                        </div>
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-node-js text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">Node.js</h6>
                            </div>
                        </div>
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-python text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">Python</h6>
                            </div>
                        </div>
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-php text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">PHP</h6>
                            </div>
                        </div>
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-js text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">JavaScript</h6>
                            </div>
                        </div>
                        <div className="col-4 col-md-2">
                            <div className="bg-white p-3 rounded shadow">
                                <i className="fab fa-wordpress text-primary fa-3x mb-2"></i>
                                <h6 className="mb-0">WordPress</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact CTA Section */}
            {/* <div className="container-xxl py-5">
                <div className="container">
                    <div className="bg-light rounded p-5 text-center" data-aos="zoom-in" data-aos-delay="100">
                        <h2 className="mb-3">Ready to Build Your Digital Presence?</h2>
                        <p className="mb-4">Let's discuss your web development needs and create a solution that drives your business forward.</p>
                        <a href="/contact" className="btn btn-primary py-3 px-5">
                            <i className="fa fa-envelope me-2"></i> Contact Us for Consultation
                        </a>
                    </div>
                </div>
            </div> */}

            <style jsx>{`
                .page-header {
background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;                }                }
            `}</style>
        </>
    );
}

export default Web;







